import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import Logger from "@/assets/Helper/Logger";
import VueAnalytics from "vue-analytics";

Vue.config.productionTip = false

Vue.config.errorHandler = function (error, vm, info) {
    Logger.vueError(error, vm, info);
};

let analyticsId = (typeof window.conf2020AppConfig.analyticsId === 'string' && window.conf2020AppConfig.analyticsId !== "") ? window.conf2020AppConfig.analyticsId : ""
let disableTracking = (typeof window.conf2020AppConfig.tracking === 'boolean' && window.conf2020AppConfig.tracking === false && analyticsId !== "");

Vue.use(VueAnalytics, {
    id: analyticsId,
    disabled: disableTracking
});

new Vue({
    i18n,
    render: h => h(App)
}).$mount('#app');
